import React from 'react';
import { Link } from 'react-router-dom';
import { Inbox, CalendarClock, Camera, Wand2, Send, BadgeCheck } from 'lucide-react';

const STATUS_CARDS = [
  { key: 'requested', label: 'New', icon: Inbox, accent: true },
  { key: 'scheduled', label: 'Scheduled', icon: CalendarClock },
  { key: 'shot', label: 'Shot', icon: Camera },
  { key: 'editing', label: 'Editing', icon: Wand2 },
  { key: 'delivered', label: 'Delivered', icon: Send },
  { key: 'paid', label: 'Paid', icon: BadgeCheck },
];

export const StatusCounts = ({ counts, loading }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3" data-testid="dashboard-status-counts">
    {STATUS_CARDS.map(({ key, label, icon: Icon, accent }, i) => (
      <Link
        key={key}
        to={`/admin/real-estate-orders?status=${key}&service=all`}
        data-testid={`dashboard-count-${key}`}
        style={{ animationDelay: `${i * 50}ms` }}
        className={`group rounded-xl border p-4 bg-[#0f1724] hover:-translate-y-0.5 transition-[transform,border-color] duration-200 animate-in fade-in slide-in-from-bottom-2 fill-mode-both ${
          accent ? 'border-[#C6A14A]/50 hover:border-[#C6A14A]' : 'border-white/10 hover:border-[#C6A14A]/50'
        }`}
      >
        <div className="flex items-center justify-between">
          <span className={`text-xs uppercase tracking-[0.15em] ${accent ? 'text-[#C6A14A]' : 'text-[#E8E4DE]/60'}`}>{label}</span>
          <Icon className="h-4 w-4 text-[#C6A14A]/70" />
        </div>
        <p className="text-3xl font-light text-white mt-2 group-hover:text-[#C6A14A] transition-colors" data-testid={`dashboard-count-${key}-value`}>
          {loading ? '…' : counts?.[key] ?? 0}
        </p>
      </Link>
    ))}
  </div>
);
